import { BackendModel, BackendService } from '../../core/backend.service';

export class Sector extends BackendModel {

  static path = '/subclientes/sectores/';

  id: number;
  description: string;

  constructor(protected backendService: BackendService, model?: Sector) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/sectores/sector.model.ts